<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تراکنش آفلاین
        </b-button>
      </b-col>
    </b-row>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage"  />
        <!-- <search ref="countriesSearchComponent" class="w-50" v-model="searchInput" /> -->
      </div>

    </div>
    <b-sidebar
        width="700px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تراکنش آفلاین" : "ایجاد تراکنش آفلاین" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-row>
          <b-form-group class="col-md-12">
            <label for="admin_user" class="text-capitalize"> انتخاب مهمان (اگه در لیست نیست بعنوان کاربر آن را ثبت نمایید) :</label>
            <v-select
                id="owner_user"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="offlineInput.guest_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :get-option-label="(option) => option.full_name"
                :reduce="(user) => user.id"
                :options="users"

                placeholder="برای جستجو تایپ کنید"
            >
              <template #option="{ full_name, mobile }">
                {{ full_name }}
                <br />
                <cite>{{ mobile }}</cite>
              </template>
            </v-select>
          </b-form-group>


          <b-form-group class="col-md-12">
            <label for="admin_user" class="text-capitalize"> انتخاب اقامتگاه  :</label>
            <v-select
                id="owner_user"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="offlineInput.serviceable_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :get-option-label="(option) => option.name"
                :reduce="(residence) => residence.id"
                :options="residences"
                placeholder="برای جستجو تایپ کنید"
            >
              <template #option="{ name,id }" style="direction: ltr">
                <cite>{{name}}</cite>

              </template>
            </v-select>
          </b-form-group>

          <b-form-group  class="col-md-6">
            <label for="name" class="text-capitalize"> تاریخ شروع : </label>
            <b-form-input class="my-custom-editable-input1" type="text" />
            <date-picker
                auto-submit
                clearable
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                v-model="offlineInput.checkin"
                custom-input=".my-custom-editable-input1"
            />
          </b-form-group>
          <b-form-group  class="col-md-6">
            <label for="name" class="text-capitalize"> تاریخ پایان : </label>
            <b-form-input class="my-custom-editable-input2" type="text" />
            <date-picker
                auto-submit
                clearable
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                v-model="offlineInput.checkout"
                custom-input=".my-custom-editable-input2"
            />
          </b-form-group>
          <b-form-group  class="col-md-12">
            <label for="price_pay_host" class="text-capitalize"
            >هزینه تسویه حساب با میزبان :  <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                :formatter="formatnumber"
                v-model="offlineInput.price_pay_host"
                id="price_pay_host"
                key="price_pay_host"
                placeholder="2"
            />
          </b-form-group>

          <b-form-group class="col-md-12">
            <label for="title" class="text-capitalize"
            > تعداد نفرات <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                v-model="offlineInput.people"
                id="title"
                key="title1"
                placeholder="تعداد نفرات"
            />
          </b-form-group>


          <b-form-group class="col-md-12">
            <label for="title" class="text-capitalize"
            > مدت اجرا : <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                v-model="offlineInput.duration"
                id="title"
                key="title1"
                placeholder="تعداد نفرات"
            />
          </b-form-group>

          <b-form-group  class="col-md-12">
            <label for="payment_price_site" class="text-capitalize"
            >مبلغ پرداختی به سایت  :  <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                :formatter="formatnumber"
                v-model="offlineInput.payment_price_site"
                id="payment_price_site"
                key="payment_price_site1"
                placeholder="0"
            />
          </b-form-group>

          <b-form-group  class="col-md-12">
            <label for="payment_price_area" class="text-capitalize"
            >هزینه پرداختی در محل  :  <span class="text-danger">*</span></label
            >
            <b-form-input
                lazy
                :formatter="formatnumber"
                v-model="offlineInput.payment_price_area"
                id="payment_price_area"
                key="payment_price_area"
                placeholder="0"
            />
          </b-form-group>


          <b-form-group class="col-md-12">
            <label for="residence_area" class="text-capitalize">
              وضعیت پرداخت :<span class="text-danger">*</span>
            </label>
            <v-select
                id="residence_area"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="offlineInput.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="payStatus"
            />
          </b-form-group>

          <b-form-group class="col-md-12">
            <label for="residence_area" class="text-capitalize">
              انتخاب کارت بانکی :<span class="text-danger">*</span>
            </label>
            <v-select
                id="residence_area"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="offlineInput.card"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="cardBank"
            />
          </b-form-group>

        </b-row>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      residences: [],
      users: [],
      countries: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      cardBank: [
        "بانک صادرات ",
        "بانک پاسارگارد",
        "سایر بانک ها",
      ],
      payStatus: [
        "تایید شده ",
        " کنسل شده",
        "سایر موارد ",
      ],
      offlineInput: {
        id: "",
        title: "",
        guest_id: "",
        serviceable_table: "residence",
        serviceable_id: "",
        checkin: "",
        checkout: "",
        price_pay_host: "",
        payment_price_area:"",
        payment_price_site: "",
        card: "",
        status: "",
        people: "",
        duration: "",

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getSpaces();
    this.getUsers();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;

    },
    perPage(value) {
      this.page = 1;

    },
    page(value) {

    },
  },
  methods: {
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCounties();
    },

    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },


    getSpaces(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };
      const requestData = {
        method: "get",
        url: "/site/residences/sitemap",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.residences = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },



    showConfirmModal(country) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف تراکنش آفلاین مطمئن هستید ؟" +
              `: ${country.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let countryIndex = 0;
              this.countries = await this.countries.filter((countryItem, index) => {
                if (countryItem.id == country.id) {
                  countryIndex = index;
                }
                return countryItem.id !== country.id;
              });

              const requestData = {
                method: "delete",
                url: `/admin/countries/${country.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `تراکنش آفلاین: ${country.name} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.countries.splice(countryIndex, 0, country);
                  });
            }
          });
    },
    showFormModal(country) {
      if (country) {
        this.countryInput = {
          id: country.id,
          name: country.name,
          slug:country.slug,
          status:country.status,

        };
        this.editMode = true;
      } else {
        this.countryInput = {
          name: "",
          slug:"",
          status:"active",

        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;

      if (!errorMessage && !this.countryInput.name) {
        errorMessage = "لطفا نام تراکنش آفلاین را وارد کنید";
      }
      if (!errorMessage && this.countryInput.name.length < 2) {
        errorMessage = "نام تراکنش آفلاین نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.countryInput.slug) {
        errorMessage = "لطفا اسلاگ تراکنش آفلاین را وارد کنید";
      }
      if (!errorMessage && this.countryInput.slug.length < 2) {
        errorMessage = "اسلاگ تراکنش آفلاین نمی تواند کمتر از دو کاراکتر باشد";
      }


      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode ? `/admin/countries/${this.countryInput.id}` : `/admin/countries`,
        data: this.countryInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "تراکنش آفلاین با موفقیت اضافه شد";
            if (this.editMode) message = "تراکنش آفلاین با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.countries && this.countries.length > 0) {
              this.$refs.countriesPaginationComponent.clear();
              // this.$refs.countriesSearchComponent.clear();
              this.$refs.countriesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getCounties();
          })
          .catch((err) => {
            let message = "خطا در ایجاد تراکنش آفلاین";
            if (this.editMode) message = "خطا در ویرایش تراکنش آفلاین";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
